import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store.js'

import UUID from "vue-uuid";
Vue.use(UUID);

require('./firebaseConfig.js')

import { BootstrapVue } from 'bootstrap-vue'
//import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

import VueMeta from 'vue-meta'
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

import '@/assets/css/style.scss'
import './registerServiceWorker'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
